export const REQUEST_PARTNER_LIST = "REQUEST_PARTNER_LIST"
export const REQUEST_PARTNER_LIST_FOR_CREATE = "REQUEST_PARTNER_LIST_FOR_CREATE"
export const REQUEST_PARTNER = "REQUEST_PARTNER"